module.exports = "/assets/bees-total.png";